import {Radio, Tooltip} from "@blueprintjs/core";
import {InputContainer, Input} from "./styles";
import {StyledRadioGroup} from "../../../common/StyledRadioGroup";
import {ContentOption, ContentProps} from "./components/Content";
import {UnitText, SingleSelectButton, SingleSelectItem} from "./styles";
import {ItemRenderer, Select} from "@blueprintjs/select";
import {DEFAULT_POPOVER_MODIFIERS} from "../../../../constants/constants";

export const renderRadioGroupProps = (contentProps: ContentProps) => {
  const {handleChangeOption, selectedOption, contentOptions, isDisabled, tooltipContent} = contentProps;
  return (
    <Tooltip
      popoverClassName="content-tooltip"
      content={tooltipContent?.()}
      placement="top-start"
      interactionKind="hover"
      hoverCloseDelay={400}
    >
      <StyledRadioGroup onChange={handleChangeOption} selectedValue={selectedOption} disabled={isDisabled()}>
        {contentOptions.map((option) => (
          <Radio
            data-testid={`radio-${option.group}-${option.value}`}
            key={option.value}
            label={option.label}
            value={option.value}
            radioGroup={option.group}
          />
        ))}
      </StyledRadioGroup>
    </Tooltip>
  );
};

export const renderNumericTextBox = (contentProps: ContentProps) => {
  const {handleChangeOption, selectedOption, contentUnit, isDisabled, contentTitle, handleBlur, tooltipContent} =
    contentProps;
  return (
    <InputContainer>
      <Tooltip
        popoverClassName="content-tooltip"
        content={tooltipContent?.()}
        placement="top-start"
        interactionKind="hover"
        hoverCloseDelay={400}
      >
        <Input
          type="text"
          placeholder="ex. 15"
          value={selectedOption}
          onChange={handleChangeOption}
          data-testid={`${contentTitle.replaceAll(" ", "-").toLowerCase()}-input`}
          disabled={isDisabled()}
          onBlur={handleBlur}
        />
      </Tooltip>
      <UnitText data-testid="unit-text">{contentUnit}</UnitText>
    </InputContainer>
  );
};

export const renderSingleSelect = (contentProps: ContentProps) => {
  const {handleChangeOption, selectedOption, contentOptions, isDisabled, tooltipContent} = contentProps;

  const handleItemSelect = (item: ContentOption) => {
    const formEvent = {
      currentTarget: {
        value: item.value,
        name: contentProps.contentTitle,
        type: "select"
      }
    } as React.FormEvent<HTMLInputElement>;
    handleChangeOption(formEvent);
  };

  const renderItem: ItemRenderer<ContentOption> = (item, {handleClick}) => {
    return (
      <SingleSelectItem key={item.value} isSelected={selectedOption === item.value} onClick={handleClick}>
        {item.value}
      </SingleSelectItem>
    );
  };

  return (
    <Tooltip
      popoverClassName="content-tooltip"
      content={tooltipContent?.()}
      placement="top-start"
      interactionKind="hover"
      hoverCloseDelay={400}
    >
      <Select<ContentOption>
        onItemSelect={handleItemSelect}
        itemRenderer={renderItem}
        disabled={isDisabled()}
        items={contentOptions}
        filterable={false}
        popoverProps={{
          minimal: true,
          matchTargetWidth: true,
          modifiers: DEFAULT_POPOVER_MODIFIERS
        }}
      >
        <SingleSelectButton
          variant="minimal"
          text={selectedOption}
          endIcon="chevron-down"
          data-testid={`${contentProps.contentTitle.replaceAll(" ", "-").toLowerCase()}-select`}
          disabled={isDisabled()}
        />
      </Select>
    </Tooltip>
  );
};
